import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider } from "./lib/auth";
import { Layout, RequireOwner } from "./components/Layout";
import { GoogleAuthCallback } from "./components/GoogleAuthCallback";
import Kasir from "./pages/Kasir";
import Meja from "./pages/Meja";
import Stok from "./pages/Stok";
import Belanja from "./pages/Belanja";
import Riwayat from "./pages/Riwayat";
import Laporan from "./pages/Laporan";
import Laba from "./pages/Laba";
import Pelanggan from "./pages/Pelanggan";
import Promo from "./pages/Promo";
import PesananOnline from "./pages/PesananOnline";
import Pengaturan from "./pages/Pengaturan";
import LabelHarga from "./pages/LabelHarga";
import TokoOnline from "./pages/TokoOnline";
import RestoOnline from "./pages/RestoOnline";
import Akun from "./pages/Akun";
import InfoToko from "./pages/InfoToko";
import ProdukDetail from "./pages/ProdukDetail";
import Login from "./pages/Login";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleAuthCallback />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/kasir" element={<Kasir />} />
        <Route path="/meja" element={<Meja />} />
        <Route path="/stok" element={<Stok />} />
        <Route path="/belanja" element={<RequireOwner><Belanja /></RequireOwner>} />
        <Route path="/riwayat" element={<Riwayat />} />
        <Route path="/laporan" element={<RequireOwner><Laporan /></RequireOwner>} />
        <Route path="/laba" element={<RequireOwner><Laba /></RequireOwner>} />
        <Route path="/pelanggan" element={<RequireOwner><Pelanggan /></RequireOwner>} />
        <Route path="/promo" element={<RequireOwner><Promo /></RequireOwner>} />
        <Route path="/pesanan" element={<PesananOnline />} />
        <Route path="/label" element={<LabelHarga />} />
        <Route path="/pengaturan" element={<RequireOwner><Pengaturan /></RequireOwner>} />
      </Route>
      <Route path="/" element={<TokoOnline />} />
      <Route path="/toko" element={<TokoOnline />} />
      <Route path="/resto" element={<RestoOnline />} />
      <Route path="/akun" element={<Akun />} />
      <Route path="/info" element={<InfoToko />} />
      <Route path="/produk/:id" element={<ProdukDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
